import React from 'react';
import {
  BrowserRouter,
  Route,
  Routes as RouterRoutes,
} from 'react-router-dom';
import AuthRoute from './AuthRoute';
import Home from '../pages/home/Home';
import InitialPage from '../pages/initial/InitialPage';
import Login from '../pages/login/Login';
import NotFound from '../pages/notFound/NotFound';
import ForgotPassword from '../pages/forgotPassword/ForgotPassword';
import ChangePassword from '../pages/changePassword/ChangePassword';
import ResetPassword from '../pages/resetPassword/ResetPassword';
import EmailConfirmation from '../pages/emailConfirmation/EmailConfirmation';
import ManageUser from '../pages/user/manageUser/ManageUser';
import AssociateProfile from '../pages/user/associateProfile/AssociateProfile';
import FlowService from '../pages/service/flowService/FlowService';
import ListServices from '../pages/service/listServices/ListServices';
import ServiceDetail from '../pages/service/serviceDetail/ServiceDetail';
import EditService from '../pages/service/editService/EditService';
import '../assets/styles/styles.scss';
import ListUsers from '../pages/listUsers/ListUsers';
import ListRoles from '../pages/roles/listRoles/ListRoles';
import ManageRole from '../pages/roles/manageRole/ManageRole';
import PageLogs from '../pages/system/pageLogs/PageLogs';
import EquipamentModel from '../pages/system/equipamentModel/EquipamentModel';
import ServiceStatus from '../pages/serviceStatus/ServiceStatus';
import ImportShapefiles from '../pages/service/shapefile/ImportShapefiles';
import Results from '../pages/service/results/Results';
import ProfileEdit from '../pages/profileEdit/ProfileEdit';
import Parameters from '../pages/system/parameters/Parameters';
// import AccountsPayableDetails from '../pages/financial/accountsPayable/details/AccountsPayableDetails';
// import ListPayables from '../pages/financial/accountsPayable/listPayables/ListPayables';
import ColetaPorTalhoesFlow from '../pages/service/geofert/coletaPorTalhoes/flow/Flow';
import ClassificacaoSoloFlow from '../pages/service/geofert/classificacaoSoloAmbienteProducao/flow/Flow';
import GridFlow from '../pages/service/geofert/grid/flow/Flow';
import ZonaDeManejo from '../pages/service/geofert/zonaDeManejo/flow/Flow';
import VantOrtoFlow from '../pages/service/vant/ortomosaico/flow/Flow';
import VantSistematizacaoFlow from '../pages/service/vant/sistematizacao/flow/Flow';
import VantProjetoPlantioFlow from '../pages/service/vant/projetoDePlantio/flow/Flow';
import VantLevantamentoFalhasFlow from '../pages/service/vant/levantamentoDeFalhas/flow/Flow';
import VantMapeamentoLinhasFlow from '../pages/service/vant/mapeamentoDeLinhas/flow/Flow';
import VantMapErvasInvasorasFlow from '../pages/service/vant/mapeamentoDeErvasInvasoras/flow/Flow';
import VantZonaManejoFlow from '../pages/service/vant/zonaDeManejo/flow/Flow';
import ListServiceEstimates from '../pages/service/serviceEstimates/listServiceEstimates/ListServiceEstimates';
import EstimateStatus from '../pages/serviceStatus/estimateStatus/EstimateStatus';
import ServiceEstimateDetail from '../pages/service/serviceDetail/estimateDetail/ServiceEstimateDetail';
import EditEstimate from '../pages/service/editService/editEstimate/EditEstimate';
import AssistenciaTecnica from '../pages/service/posVendas/assistenciaTecnica/flow/Flow';
import LocacaoPiloto from '../pages/service/posVendas/locacaoPiloto/flow/Flow';
import MontagemEquipamento from '../pages/service/posVendas/montagemEquipamento/flow/Flow';
import NotificationSettings from '../pages/notificationSettings/NotificationSettings';
import ListEvents from '../pages/events/listEvents/ListEvents';
import ManageEvent from '../pages/events/manageEvent/ManageEvent';
import Notifications from '../pages/system/Notifications/Notifications';
import Branches from '../pages/system/branches/Branches';
import ManageBranches from '../pages/system/branches/ManageBranches';
import ManageNotification from '../pages/system/Notifications/ManageNotification';
/* import Credit from '../pages/fidelity/credit/Credit'; */
/* import Simulator from '../pages/fidelity/simulator/Simulator'; */
/* import CreditBalance from '../pages/fidelity/creditBalance/CreditBalance'; */
import ListCategories from '../pages/notificationCategories/listCategories/ListCategories';
import ManageCategory from '../pages/notificationCategories/manageCategory/ManageCategory';
import DeleteAccount from '../pages/deleteAccount/DeleteAccount';
import AccountDeletionRequests from '../pages/accountDeletionRequests/AccountDeletionRequests';
import BaseYearExercises from '../pages/baseYearExercises/BaseYearExercises';
import ReportIncome from '../pages/reportIncome/ReportIncome';
import DownloadNf from '../pages/downloadNf/DownloadNf';
import ServiceInvoice from '../pages/system/serviceInvoice/ServiceInvoice';

import {
  getUserPermissions,
} from '../utils/users';
import BankPaymentSlip from '../pages/bankPaymentSlip/BankPaymentSlip';

const Routes = (): React.ReactElement => (
  <BrowserRouter>
    <RouterRoutes>
      <Route
        path="/"
        element={(
          <AuthRoute permissions={['basico']}>
            <InitialPage />
          </AuthRoute>
        )}
      />

      <Route
        path="/home"
        element={(
          <AuthRoute permissions={['basico']}>
            <Home />
          </AuthRoute>
        )}
      />

      <Route
        path="/change-password/"
        element={(
          <AuthRoute permissions={['basico']}>
            <ChangePassword />
          </AuthRoute>
        )}
      />

      <Route
        path="/user/list"
        element={(
          <AuthRoute permissions={['Cadastro de usuários']}>
            <ListUsers />
          </AuthRoute>
        )}
      />

      {/* <Route
        path="/user/register"
        element={(
          <AuthRoute permissions={['Cadastro de usuários']}>
            <ManageUser />
          </AuthRoute>
        )}
      /> */}

      <Route
        path="/user/edit/:id"
        element={(
          <AuthRoute permissions={['Cadastro de usuários']}>
            <ManageUser />
          </AuthRoute>
        )}
      />

      <Route
        path="/admin/edit/:id"
        element={(
          <AuthRoute permissions={['Cadastro de usuários']}>
            <ManageUser />
          </AuthRoute>
        )}
      />

      <Route
        path="/roles/list"
        element={(
          <AuthRoute permissions={['Perfis de usuário']}>
            <ListRoles />
          </AuthRoute>
        )}
      />

      <Route
        path="/roles/create"
        element={(
          <AuthRoute permissions={['Perfis de usuário']}>
            <ManageRole />
          </AuthRoute>
        )}
      />

      <Route
        path="/roles/:id/edit"
        element={(
          <AuthRoute permissions={['Perfis de usuário']}>
            <ManageRole />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço', 'Solicitar novo orçamento']}>
            <FlowService />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/geofert/coletaportalhoes/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço', 'Solicitar novo orçamento']}>
            <ColetaPorTalhoesFlow />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/geofert/zonaDeManejo/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço', 'Solicitar novo orçamento']}>
            <ZonaDeManejo />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/geofert/classificacaosolo/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço', 'Solicitar novo orçamento']}>
            <ClassificacaoSoloFlow />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/geofert/grid/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço', 'Solicitar novo orçamento']}>
            <GridFlow />
          </AuthRoute>
        )}

      />

      <Route
        path="/service/vant/ortomosaico/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço', 'Solicitar novo orçamento']}>
            <VantOrtoFlow />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/vant/sistematizacao/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço', 'Solicitar novo orçamento']}>
            <VantSistematizacaoFlow />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/vant/projetoplantio/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço', 'Solicitar novo orçamento']}>
            <VantProjetoPlantioFlow />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/vant/levantamentofalhas/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço', 'Solicitar novo orçamento']}>
            <VantLevantamentoFalhasFlow />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/vant/mapeamentolinhas/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço', 'Solicitar novo orçamento']}>
            <VantMapeamentoLinhasFlow />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/vant/mapeamentoervasinvasoras/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço', 'Solicitar novo orçamento']}>
            <VantMapErvasInvasorasFlow />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/vant/zonamanejo/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço', 'Solicitar novo orçamento']}>
            <VantZonaManejoFlow />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/list"
        element={(
          <AuthRoute permissions={['Visualizar serviços solicitados', 'Controlar serviços solicitados']}>
            <ListServices />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/estimates"
        element={(
          <AuthRoute permissions={['Visualizar orçamentos solicitados', 'Controlar orçamentos solicitados']}>
            <ListServiceEstimates />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/estimates/:id/details"
        element={(
          <AuthRoute permissions={['Visualizar orçamentos solicitados', 'Controlar orçamentos solicitados']}>
            <ServiceEstimateDetail />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/edit/:id"
        element={(
          <AuthRoute permissions={['Controlar serviços solicitados']}>
            <EditService />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/estimates/:id/edit"
        element={(
          <AuthRoute permissions={['Controlar orçamentos solicitados']}>
            <EditEstimate />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/detail/:id"
        element={(
          <AuthRoute permissions={['Visualizar serviços solicitados', 'Controlar serviços solicitados']}>
            <ServiceDetail />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/status/:id"
        element={(
          <AuthRoute permissions={['Controlar serviços solicitados']}>
            <ServiceStatus />
          </AuthRoute>
        )}
      />

      <Route
        path="/estimate/status/:id"
        element={(
          <AuthRoute permissions={['Controlar orçamentos solicitados']}>
            <EstimateStatus />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/shapefiles/import"
        element={(
          <AuthRoute permissions={['Importar shapefiles']}>
            <ImportShapefiles />
          </AuthRoute>
        )}
      />
      <Route
        path="/service/results/results"
        element={(
          <AuthRoute
            checkPermissionExpressionMethod={
              (): boolean => {
                const userPermissions = getUserPermissions();

                if (
                  userPermissions.includes('Listagem de importação de resultados')
                    && (
                      userPermissions.includes('Solicitar novo orçamento')
                      || userPermissions.includes('Solicitar novo serviço')
                    )
                ) {
                  return true;
                }

                return false;
              }
            }
          >
            <Results />
          </AuthRoute>
        )}
      />

      <Route
        path="/profile/associate/:id"
        element={(
          <AuthRoute permissions={['Usuários do perfil']}>
            <AssociateProfile />
          </AuthRoute>
        )}
      />

      <Route
        path="/profile/edit-my-profile"
        element={(
          <AuthRoute permissions={['Meu perfil']}>
            <ProfileEdit />
          </AuthRoute>
        )}
      />

      <Route
        path="/system/parameters"
        element={(
          <AuthRoute permissions={['Parâmetros do sistema']}>
            <Parameters />
          </AuthRoute>
        )}
      />

      <Route
        path="/system/logs"
        element={(
          <AuthRoute permissions={['Relatório de logs do sistema']}>
            <PageLogs />
          </AuthRoute>
        )}
      />
      <Route
        path="/system/equipamentModel"
        element={(
          <AuthRoute permissions={['basico']}>
            <EquipamentModel />
          </AuthRoute>
        )}
      />
      <Route
        path="/system/branches"
        element={(
          <AuthRoute permissions={['Visualizar filiais solicitados']}>
            <Branches />
          </AuthRoute>
        )}
      />
      <Route
        path="/system/branches/new"
        element={(
          <AuthRoute permissions={['Solicitar nova filial']}>
            <ManageBranches />
          </AuthRoute>
        )}
      />
      <Route
        path="/system/branches/:id/edit"
        element={(
          <AuthRoute permissions={['Editar filial']}>
            <ManageBranches />
          </AuthRoute>
        )}
      />

      <Route
        path="/system/notifications"
        element={(
          <AuthRoute permissions={['Visualizar notificações']}>
            <Notifications />
          </AuthRoute>
        )}
      />

      <Route
        path="/system/notifications/new"
        element={(
          <AuthRoute permissions={['Solicitar notificações']}>
            <ManageNotification />
          </AuthRoute>
        )}
      />

      <Route
        path="/system/notifications/:id/edit"
        element={(
          <AuthRoute permissions={['Editar notificações']}>
            <ManageNotification />
          </AuthRoute>
        )}
      />

      {/* <Route
        path="/fidelity/credit"
        element={(
          <AuthRoute permissions={['Conversão de crédito por serviço (escrita)']}>
            <Credit />
          </AuthRoute>
        )}
      /> */}

      {/* <Route
        path="/fidelity/simulator"
        element={(
          <AuthRoute permissions={['Simulador de aquisição']}>
            <Simulator />
          </AuthRoute>
        )}
      /> */}

      {/* <Route
        path="/fidelity/creditbalance"
        element={(
          <AuthRoute permissions={['Saldo de créditos']}>
            <CreditBalance />
          </AuthRoute>
        )}
      /> */}

      {/* <Route
        path="/financial/payables/"
        element={(
          <AuthRoute permissions={['Contas a pagar']}>
            <ListPayables />
          </AuthRoute>
        )}
      /> */}

      {/* <Route
        path="/financial/payables/invoice/:matricula/:numeroNF/:parcela"
        element={(
          <AuthRoute permissions={['Contas a pagar']}>
            <AccountsPayableDetails />
          </AuthRoute>
        )}
      /> */}

      {/* <Route
        path="/financial/payables/payable/:matricula/:numeroTitulo/:parcela/:dataEmissao"
        element={(
          <AuthRoute permissions={['Contas a pagar']}>
            <AccountsPayableDetails />
          </AuthRoute>
        )}
      /> */}

      <Route
        path="/service/posVendas/assistenciaTecnica/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço']}>
            <AssistenciaTecnica />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/posVendas/locacaoPiloto/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço']}>
            <LocacaoPiloto />
          </AuthRoute>
        )}
      />

      <Route
        path="/service/posVendas/montagemEquipamento/new"
        element={(
          <AuthRoute permissions={['Solicitar novo serviço']}>
            <MontagemEquipamento />
          </AuthRoute>
        )}
      />

      <Route
        path="/notification/settings"
        element={(
          <AuthRoute permissions={['Notificações']}>
            <NotificationSettings />
          </AuthRoute>
        )}
      />

      <Route
        path="/events/new"
        element={(
          <AuthRoute permissions={['Solicitar novo evento']}>
            <ManageEvent />
          </AuthRoute>
        )}
      />

      <Route
        path="/events/:id/edit"
        element={(
          <AuthRoute permissions={['Editar evento']}>
            <ManageEvent />
          </AuthRoute>
        )}
      />

      <Route
        path="/events"
        element={(
          <AuthRoute permissions={['basico']}>
            <ListEvents />
          </AuthRoute>
        )}
      />

      <Route
        path="/notificationcategories"
        element={(
          <AuthRoute permissions={['Listagem de categoria']}>
            <ListCategories />
          </AuthRoute>
        )}
      />

      <Route
        path="/notificationcategories/:id/edit"
        element={(
          <AuthRoute permissions={['Editar categoria']}>
            <ManageCategory />
          </AuthRoute>
        )}
      />

      <Route
        path="/notificationcategories/new"
        element={(
          <AuthRoute permissions={['Solicitar nova categoria']}>
            <ManageCategory />
          </AuthRoute>
        )}
      />

      <Route
        path="/delete-account"
        element={(
          <AuthRoute permissions={['basico']}>
            <DeleteAccount />
          </AuthRoute>
        )}
      />

      <Route
        path="/base-year-exercises"
        element={(
          <AuthRoute permissions={['basico']}>
            <BaseYearExercises />
          </AuthRoute>
        )}
      />

      <Route
        path="/account-deletion-requests"
        element={(
          <AuthRoute permissions={['Solicitações de exclusão de conta']}>
            <AccountDeletionRequests />
          </AuthRoute>
        )}
      />

      <Route
        path="/report-income"
        element={(
          <AuthRoute permissions={['basico']}>
            <ReportIncome />
          </AuthRoute>
        )}
      />

      <Route
        path="/download-nf"
        element={(
          <AuthRoute permissions={['basico']}>
            <DownloadNf />
          </AuthRoute>
        )}
      />

      <Route
        path="/service-invoice"
        element={(
          <AuthRoute permissions={['basico']}>
            <ServiceInvoice />
          </AuthRoute>
        )}
      />

      <Route
        path="/bank-payment-slip"
        element={(
          <AuthRoute permissions={['basico']}>
            <BankPaymentSlip />
          </AuthRoute>
        )}
      />

      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/email-confirmation/:token" element={<EmailConfirmation />} />
      <Route path="*" element={<NotFound />} />
    </RouterRoutes>
  </BrowserRouter>
);

export default Routes;
